<template>
  <div class="title-section">
    <div :class="'title-line' + (border ? ' border': '')">
      <slot name="header" v-if="$slots.header"></slot>
      <div class="title-line-title" v-else>
        <slot name="title" v-if="$slots.title"></slot>
        <span v-else>
          <i class="el-icon-caret-right"></i>
          <b>{{title}}</b>
        </span>
        <slot name="description" v-if="$slots.description"></slot>
        <span class="description" v-else-if="description">{{description}}</span>
      </div>
      <div class="title-line-tools">
        <slot name="tools"></slot>
        <el-button type="text"
                   v-if="collapsible"
                   :icon="collapsed? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                   @click="collapsed = !collapsed"></el-button>
      </div>
    </div>
    <div class="title-section-body" :style="{display: collapsed? 'none': 'block'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    border: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      collapsed: false
    }
  }
}
</script>

<style scoped lang="scss">
.title-section {
  .title-line {
    padding: 7px 0;
    margin: 30px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      font-size: 16px;

      i {
        padding: 0 5px;
      }

      span {
        font-weight: 600;
        font-size: 16px;
      }

      span.description {
        margin-left: 10px;
        font-size: 12px;
        font-weight: 500;
      }
    }

    &-tools {
    }
  }

  .title-line.border {
    border-bottom: 1px solid #ddd;
  }
}
</style>